// Бренд-конфиг витрины (мультиклиентность).
// Контент-пак выбирается на этапе сборки через REACT_APP_BRAND (дефолт — stems),
// точечные ссылки можно переопределить отдельными REACT_APP_* без нового пака.
// Мета-теги/title/Метрика живут не здесь, а в public/index.html (%REACT_APP_%-подстановки).

const PACKS = {
  stems: {
    name: 'STEMS',
    // В ШАПКЕ тэглайн скрыт CSS-ом (редизайн 2026-08-10, STEMS по центру);
    // значение живо — его показывает hero страницы «О проекте».
    tagline: 'RAW FLOWERS ONLY',
    // Лого шапки: text → рендерится имя бренда; image → { type: 'image', src: '/brands/<brand>/logo.svg', height: 24 }
    logo: { type: 'text' },
    navIconStyle: 'line', // линейные SVG вместо эмодзи в нижней навигации (редизайн 2026-08-10)
    // Дизайн-токены бренда — ЕДИНСТВЕННЫЙ источник цветов приложения.
    // Подставляются в CSS-переменные при старте (src/theme.js), в CSS/компонентах значений нет.
    theme: {
      primary: '#FEF67F',        // фирменный акцент: кнопки, карточка счёта, табы
      primaryHover: '#F5ED6F',   // нажатие/ховер акцента
      primaryLight: '#E8F0A0',   // светлые подложки акцента
      onPrimary: '#1A1A1A',      // цвет текста ПОВЕРХ акцента (у тёмных брендов — белый)
      primarySoftBg: 'linear-gradient(135deg, #FFF9E6 0%, #FEF67F22 100%)', // мягкий брендовый фон (карточки-подсказки)
      bg: '#FFFFFF',             // фон приложения
      text: '#1A1A1A',           // основной текст
      textSecondary: '#666666',  // вторичный текст
      cardBg: '#F7F7F7',         // фон карточек
      border: '#EBEBEB',         // бордеры
      success: '#4CAF50',        // успех (галочки, статусы)
      // Шрифты: ИМЕНА здесь, а URL подключения (Google Fonts и т.п.) — build-арг
      // REACT_APP_FONTS_CSS_URL (см. Dockerfile.prod) — статике index.html пак недоступен
      fontHeading: "'Montserrat', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
      // Исторически ВЕСЬ Стемс на Montserrat (body в styles.css до механизма
      // тем); Inter в пак попал по ошибке и менял вид основного текста
      fontBody: "'Montserrat', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
    },
    ofertaUrl: 'https://telegra.ph/PUBLICHNAYA-OFERTA-STEMS-02-19',
    // Раньше стояло https://stems.ru/policy — stems.ru не наш домен (404, чужой
    // сертификат); единственная живая политика — telegra.ph от 22.04.2026.
    policyUrl: 'https://telegra.ph/POLITIKA-KONFIDENCIALNOSTI-I-OBRABOTKI-PERSONALNYH-DANNYH-SERVISA-STEMSBOT-04-22',
    updateAlert:
      'У Stems вышли обновления, для корректной работы обновите приложение.\n\nС любовью, STEMS.',
    about: {
      heroEmoji: '🌱🌼🦎',
      // <strong>{name}</strong> — {philosophyIntro}
      philosophyIntro: 'первый честный цветочный бот в Казани.',
      philosophyLines: [
        'Только свежие стебли и ничего лишнего.',
        'Мы убрали всё ненужное: упаковку, ленты, наценки.',
        'Оставили главное — свежие стебли по цене оптовых баз.',
      ],
      advantages: [
        { icon: '🤑', color: 'yellow', label: 'Честные цены' },
        { icon: '🌼', color: 'yellow', label: 'Всегда свежие цветы' },
        { icon: '🦎', color: 'green', label: null }, // null → «Кешбэк на счёт {name} с каждого заказа»
        { icon: '🚀', color: 'red', label: 'Быстрая доставка в день заказа' },
      ],
      serviceFeeItems: [
        { icon: '📦', label: 'Подготовка и сбор стеблей на складе' },
        { icon: '🎁', label: 'Стильный бокс' },
        { icon: '📋', label: 'Обслуживание и налоги' },
      ],
      careTips: [
        'Подрежь стебли ножом или секатором под углом 45° и поставь в прохладную воду.',
        'Меняй воду каждый день.',
        'Держи цветы подальше от солнца и батарей.',
      ],
      deliveryLines: [
        'Курьером по Казани',
        'Самовывоз — по предварительному заказу.',
        'Оплата онлайн',
      ],
      contacts: {
        org: 'Индивидуальный предприниматель Маннапова Алия Маратовна',
        inn: '027105489345',
        ogrnip: '322028000181215',
        phone: '+7 (917) 902-00-01',
        phoneHref: 'tel:+79179020001',
      },
    },
    // Баннер-CTA сертификата в каталоге (MenuPage); показ включается в админке
    // (настройки сертификатов → show_banner). Цвета — токены темы, тексты — здесь.
    certBanner: {
      title: 'Подари букет — отправь сертификат',
      subtitle: 'Электронный сертификат на любую сумму',
    },
    // Атрибуция платформы внизу «О проекте». null → блок скрыт (белый лейбл).
    // Шрифт наследуется от бренда, ничего своего блок не задаёт.
    poweredBy: {
      text: 'Сайт и приложения магазина работают на платформе NovaFlo',
      linkLabel: 'novaflo.ru',
      url: 'https://novaflo.ru/?utm_source=stemsbot.ru&utm_medium=powered_by&utm_campaign=client_sites&utm_content=about_footer',
    },
  },
  bloooom: {
    name: 'BLOOOOM',
    tagline: '', // пусто → строка под лого не показывается (title вкладки — env REACT_APP_BRAND_TITLE)
    logo: { type: 'image', src: '/brands/bloooom/logo.svg', height: 33 }, // +50% к исходным 22px
    navIconStyle: 'line', // линейные SVG-иконки нижней навигации (дефолт — эмодзи)
    // Палитра и типографика — из бренд-гайда клиента (2026-07-27):
    // #12903C глубокий зелёный / #FFC8EB нежный розовый / #F2F2F2 чистый белый;
    // Unbounded (заголовки) + Onest (текст). Шрифтовый URL — в env инстанса.
    theme: {
      primary: '#12903C',
      primaryHover: '#0E7330',
      primaryLight: '#DFF2E6',
      onPrimary: '#FFC8EB',
      primarySoftBg: 'linear-gradient(135deg, #FFF2FA 0%, #12903C22 100%)',
      bg: '#FFFFFF',
      text: '#1A1A1A',
      textSecondary: '#666666',
      cardBg: '#F2F2F2',
      border: '#E5E5E5',
      success: '#12903C',
      fontHeading: "'Unbounded', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
      fontBody: "'Onest', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
    },
    ofertaUrl: '#', // TODO: оферта ИП Кавтарадзе (задать в админке → Юридические документы)
    policyUrl: '#', // TODO: политика ПДн ИП Кавтарадзе (аналогично)
    updateAlert:
      'У BLOOOOM вышли обновления, для корректной работы обновите приложение.',
    about: {
      heroEmoji: '🌷💚🌸',
      // Тексты согласованы с заказчиком (Георгий) 2026-08-07.
      // Срок доставки изменён с «15 минут» (черновик) на «в течение часа».
      philosophyIntro: 'охапки цветов домой, в подарок и по подписке — без звонков и долгого выбора.',
      philosophyLines: [
        'Цветы как лёгкая радость, а не редкая покупка на праздник.',
        'Красиво. Быстро. Без повода.',
        'Выбери цветы, оплати онлайн — а мы соберём и доставим их в течение часа.',
        'Никакого лишнего декора и переплат: цветы — главные.',
      ],
      advantages: [
        // Формулировка заказчика: на месте срока доставки — позиционирование бренда.
        // Текст длиннее остальных пунктов сознательно, вёрстка переносит строку.
        { icon: '⚡', color: 'green', label: 'BLOOOOM — современный цветочный сервис для тех, кто хочет покупать цветы легко, быстро и без ощущения лишней траты' },
        { icon: '🌸', color: 'green', label: 'Свежие цветы каждый день' },
        { icon: '💚', color: 'green', label: null }, // null → «Кешбэк на счёт {name} с каждого заказа»
        { icon: '🎁', color: 'green', label: 'Без лишнего: никакого декора и переплат' },
      ],
      serviceFeeItems: [
        { icon: '📦', label: 'Подготовка и сбор' },
        { icon: '🎀', label: 'Фирменная упаковка' },
        { icon: '📋', label: 'Обслуживание и налоги' },
      ],
      careTips: [
        'Подрежьте стебли под углом 45° и поставьте в прохладную воду.',
        'Меняйте воду каждый день.',
        'Держите цветы подальше от солнца и батарей.',
      ],
      deliveryLines: [
        'Курьером по Владикавказу',
        'Оплата онлайн',
      ],
      contacts: {
        org: 'Индивидуальный предприниматель Кавтарадзе Георгий Ираклиевич',
        inn: '151300437239',
        ogrnip: '314151322600020',
        phone: '+7 (989) 039-11-14',
        phoneHref: 'tel:+79890391114',
      },
    },
    certBanner: {
      title: 'Подари букет — отправь сертификат',
      subtitle: 'Электронный сертификат на любую сумму',
    },
    // Атрибуция платформы внизу «О проекте».
    // UTM обязательны: из мини-аппов referrer пустой, без меток переходы
    // придут в Метрику как прямые и эффект будет не измерить.
    poweredBy: {
      text: 'Сайт и приложения магазина работают на платформе NovaFlo',
      linkLabel: 'novaflo.ru',
      url: 'https://novaflo.ru/?utm_source=bloooom.ru&utm_medium=powered_by&utm_campaign=client_sites&utm_content=about_footer',
    },
  },
  // «Букетберри» (Киров) — третий инстанс. Палитра и лого — из брендбука клиента
  // (2026-08-28, marketing/clients/buketberi/design/): #F7F4EF основной фон,
  // #A8B5A1 графические элементы, #D68184 элементы лого и мелкие детали,
  // #766F67 линии/текст, #435549 тёмно-зелёный (шрифт лого Bondi Regular —
  // в SVG кривыми, веб-версии нет). Тексты «О проекте» — заготовки, TODO с клиентом.
  buketberi: {
    name: 'Букетберри',
    tagline: 'интернет-магазин цветов', // подпись из брендбука; в шапке скрыта CSS-ом, живёт в hero «О проекте»
    logo: { type: 'image', src: '/brands/buketberi/logo.svg', height: 60 }, // знак + словесный знак (Лого+название2); 60 (≈228px шириной) — 32 и 48 юзер счёл мелкими (2026-08-28)
    navIconStyle: 'line',
    theme: {
      primary: '#435549',        // тёмно-зелёный брендбука: кнопки, карточка счёта, табы
      primaryHover: '#364539',
      primaryLight: '#E4EAE1',   // светлая подложка на базе шалфейного #A8B5A1
      onPrimary: '#F7F4EF',      // кремовый текст на зелёном
      primarySoftBg: 'linear-gradient(135deg, #F7F4EF 0%, #D6818433 100%)', // крем → коралл лого
      bg: '#F7F4EF',             // «основной фон» брендбука
      text: '#333333',           // из палитры документа; брендбучный #766F67 для основного текста
                                 // не проходит контраст на кремовом (≈3.9:1) — оставлен вторичным
      textSecondary: '#766F67',
      cardBg: '#FFFFFF',
      border: '#DDD8D0',
      success: '#435549',
      // Веб-шрифтов брендбук не задаёт (Bondi — только лого, Calibri — офисный).
      // Предложение: Comfortaa (округлая геометрия в духе Bondi) + Nunito Sans;
      // подключение — env REACT_APP_FONTS_CSS_URL, без него — системные.
      fontHeading: "'Comfortaa', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
      fontBody: "'Nunito Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
    },
    ofertaUrl: '#', // TODO: оферта клиента (админка → Юридические документы)
    policyUrl: '#', // TODO: политика ПДн клиента
    updateAlert:
      'У Букетберри вышли обновления, для корректной работы обновите приложение.',
    about: {
      heroEmoji: '', // пусто → строки с эмодзи под лого нет (решение юзера 2026-09-16)
      // «на ленте без лишней упаковки» — формулировка клиента (2026-09-16); остальное — заготовки, TODO с клиентом
      philosophyIntro: 'свежие букеты на ленте, без лишней упаковки, с доставкой по Кирову — выбрать, оплатить онлайн и получить без звонков.',
      philosophyLines: [
        'Свежие цветы каждый день.',
        'Заказ за минуту, оплата онлайн.',
        'Соберём и доставим к нужному времени.',
      ],
      advantages: [
        { icon: '🌸', color: 'green', label: 'Свежие цветы каждый день' },
        { icon: '⚡', color: 'green', label: 'Доставка к выбранному интервалу' },
        { icon: '💚', color: 'green', label: null }, // null → «Кешбэк на счёт {name} с каждого заказа»
        { icon: '🎁', color: 'green', label: 'Подарочные сертификаты' },
      ],
      serviceFeeItems: [
        { icon: '📦', label: 'Подготовка и сбор' },
        { icon: '🎀', label: 'Фирменная упаковка' },
        { icon: '📋', label: 'Обслуживание и налоги' },
      ],
      careTips: [
        'Подрежьте стебли под углом 45° и поставьте в прохладную воду.',
        'Меняйте воду каждый день.',
        'Держите цветы подальше от солнца и батарей.',
      ],
      deliveryLines: [
        'Курьером по Кирову',
        'Оплата онлайн',
      ],
      // Реквизиты — из договора № НФ-20260910-01 (раздел 14, marketing/contracts/buketberri/);
      // юр. адрес и телефон заменены по указанию клиента 17.09.2026.
      // Юрлицо, не ИП: ogrn вместо ogrnip (AboutPage подписывает строку по наличию ключа).
      contacts: {
        org: 'Общество с ограниченной ответственностью «БУКЕТБЕРРИ»',
        inn: '4345544714',
        ogrn: '1264300005012',
        address: 'г. Киров, ул. Владимирская, д. 35',
        phone: '+7 (933) 977-14-15',
        phoneHref: 'tel:+79339771415',
        email: 'buketberri@mail.ru',
        // Подпись строки «Поддержка»; ссылка берётся из BRAND.supportUrl (env REACT_APP_SUPPORT_USERNAME) —
        // в .env инстанса должно стоять то же имя, иначе подпись и ссылка разойдутся
        support: '@buketberri_support',
      },
    },
    certBanner: {
      title: 'Не знаешь, какие цветы подарить? Подари сертификат',
      subtitle: 'Электронный сертификат на любую сумму',
    },
    poweredBy: {
      text: 'Сайт и приложения магазина работают на платформе NovaFlo',
      linkLabel: 'novaflo.ru',
      url: 'https://novaflo.ru/?utm_source=buketberi&utm_medium=powered_by&utm_campaign=client_sites&utm_content=about_footer',
    },
  },
};

// Без фолбэка на 'stems': пустой REACT_APP_BRAND раньше молча собирал витрину
// клиента с брендом Стемса. Прод-сборку без бренда останавливает Dockerfile.prod;
// dev задаёт бренд в .env.development.
const packKey = (process.env.REACT_APP_BRAND || '').toLowerCase();
const pack = PACKS[packKey];
if (!pack) {
  // Без тихих фолбэков: неизвестный бренд — это ошибка конфигурации сборки,
  // а не повод молча показать чужой бренд.
  throw new Error(`Неизвестный бренд "${packKey}" (REACT_APP_BRAND): пака нет в src/brand.js`);
}

const BRAND = {
  ...pack,
  key: packKey, // техническое имя бренда — вешается как data-brand на <html> (пер-брендовый CSS)
  // ofertaUrl/policyUrl пака — ФОЛБЭКИ: рабочие значения приходят из админ-настроек
  // (GET /api/settings), см. src/legal.js (useLegalLinks).
  // Поддержка — ТОЛЬКО из env, без фолбэка в коде: не задана → null,
  // и точки входа в поддержку не рендерятся вовсе.
  supportUrl: process.env.REACT_APP_SUPPORT_USERNAME
    ? `https://t.me/${process.env.REACT_APP_SUPPORT_USERNAME}`
    : null,
};

export default BRAND;
